import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getClinicHairServiceMasterByClinicId,
  updateClinicHairServiceDetails,
  deleteClinicHairServiceDetails,
  resetDeleteClinicHairServiceDetailsMessage,
  resetUpdateClinicHairServiceMasterMessage
} from "../../../store/slices/clinicHairServiceMaster";
import classNames from "classnames";
import styles from "../clinicLabProfile/clinicLabProfile.module.scss";
import { RiProfileLine } from "react-icons/ri";
import { Link } from "react-router-dom";
import { Dropdown, Modal } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import UpdateHairServiceDetails from "./UpdateHairServiceDetails";
import ShowTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";

const ClinicHairServiceMaster = () => {
  const serviceDetailsInitialState = {
    hairId: "",
    hairServiceId: "",
    serviceDetailName: "",
    pt_price: "",
    client_price: "",
    tax: "",
    status: "Active",
  };
  const [hairServiceDetailsFormData, setHairServiceDetailsFormData] = useState(serviceDetailsInitialState);
  const [editHairServiceModal, setEditHairServiceModal] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);
  const showTostifyMessageAndReset = ShowTostifyMessageAndReset();
  const { userInfo, token } = useSelector((state) => state.auth);
  const { clinicInfo } = useSelector((state) => state.clinic);
 const clinicId =clinicInfo?.[0]?.clinicId;
  const dispatch = useDispatch();
  const {
    clinicHairServiceMasterByClinicId,
    updateClinicHairServiceMasterSuccessMessage,
    updateClinicHairServiceMasterErrorMessage,
    deleteClinicHairServiceDetailsSuccessMessage,
    deleteClinicHairServiceDetailsErrorMessage
  } = useSelector((state) => state.clinicHairServiceMaster);

  const searchTimeout = useRef(null);
  useEffect(() => {
    dispatch(
      getClinicHairServiceMasterByClinicId({
       clinicId,
        status: ["Active", "Inactive"],
        token
      })
    );
  }, [dispatch, userInfo, clinicId, token, editHairServiceModal, deleteModal]);

  useEffect(() => {
    showTostifyMessageAndReset(updateClinicHairServiceMasterSuccessMessage, showToastifySuccess, resetDeleteClinicHairServiceDetailsMessage);
    showTostifyMessageAndReset(updateClinicHairServiceMasterErrorMessage, showToastifyError, resetDeleteClinicHairServiceDetailsMessage);
    showTostifyMessageAndReset(deleteClinicHairServiceDetailsSuccessMessage, showToastifySuccess, resetUpdateClinicHairServiceMasterMessage);
    showTostifyMessageAndReset(deleteClinicHairServiceDetailsErrorMessage, showToastifyError, resetUpdateClinicHairServiceMasterMessage);
  }, [
    updateClinicHairServiceMasterSuccessMessage,
    updateClinicHairServiceMasterErrorMessage,
    deleteClinicHairServiceDetailsSuccessMessage,
    deleteClinicHairServiceDetailsErrorMessage,
    dispatch,
    showTostifyMessageAndReset,
  ]);

  const handleChangeHairServiceFormData = (event) => {
    setHairServiceDetailsFormData({
      ...hairServiceDetailsFormData,
      [event.target.name]: event.target.value,
    });
  };

  const handleEditHairServiceDetails = (hairServiceId, value) => {
    setEditHairServiceModal(true);
    setHairServiceDetailsFormData({
      hairId: value?._id,
      clinicId: value?.clinicId?._id,
      hairServiceId,
      serviceDetailName: value?.serviceDetailName,
      pt_price: value?.pt_price,
      client_price: value?.client_price,
      tax: value?.tax,
      status: value?.status,
    });
  };

  const handleSubmitUpdateHairServiceDetails = async (event) => {
    event.preventDefault();
    try {
      await dispatch(updateClinicHairServiceDetails({ ...hairServiceDetailsFormData, token }));
      setEditHairServiceModal(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteHairServiceDetails = async (hairServiceId, value) => {
    setHairServiceDetailsFormData({
      ...hairServiceDetailsFormData,
      hairServiceId,
      serviceDetailName: value?.serviceDetailName,
      hairId: value?._id
    })
    setDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await dispatch(
        deleteClinicHairServiceDetails({
         clinicId,
          serviceId: hairServiceDetailsFormData?.hairId,
          hairMasterId: hairServiceDetailsFormData?.hairServiceId,
          token,
        })
      );
      setDeleteModal(false);
    } catch (err) {
      console.error(err);
    }
  };

 const handleSearch = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }
    searchTimeout.current = setTimeout(() => {
      if (value.trim()) {
        dispatch(
          getClinicHairServiceMasterByClinicId({
            clinicId,
            searchQuery: value,
            status: ["Active", "Inactive"],
            token,
          })
        );
      } else {
        dispatch(
          getClinicHairServiceMasterByClinicId({
           clinicId,
            status: ["Active", "Inactive"],
            token,
          })
        );
      }
    }, 300);
  };

  return (
    <>
      <div className="form-head d-flex mb-3 mb-md-4 align-items-start">
        <div className="input-group search-area ms-auto d-inline-flex me-3">
          <input
            type="text"
            className="form-control"
            placeholder="Search here"
            value={searchValue}
            onChange={handleSearch}
          />
          <div className="input-group-append">
            <button type="button" className="input-group-text">
              <FaSearch className="flaticon-381-search-2" />
            </button>
          </div>
        </div>
      </div>
      <div className="row">
        {clinicHairServiceMasterByClinicId?.length > 0 &&
          clinicHairServiceMasterByClinicId[0]?.services?.map(
            (item, index) => (
              <div className="col-lg-4 col-md-6 col-sm-1" key={index}>
                <div className="card project-boxed">
                  <div
                    className={classNames(
                      styles.titel,
                      "card-header",
                      "align-items-start"
                    )}
                  >
                    <div className={styles.titelWrapper}>
                      <RiProfileLine />
                      <h6 className="fs-18 font-w500">
                        <Link to={"#"} className="text-black user-name">
                          {item?.serviceDetailName}
                        </Link>
                      </h6>
                    </div>
                    <Dropdown className="">
                      <Dropdown.Toggle
                        variant=""
                        as="div"
                        className="btn-link i-false"
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{}}
                        >
                          <path
                            d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                            stroke="#342E59"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                            stroke="#342E59"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                            stroke="#342E59"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </Dropdown.Toggle>
                      <Dropdown.Menu align={"end"}>
                        <Dropdown.Item
                          onClick={() => handleEditHairServiceDetails(clinicHairServiceMasterByClinicId[0]?._id, item)}
                        >
                          Edit
                        </Dropdown.Item>
                        <Dropdown.Item
                          className="text-danger"
                          onClick={() => handleDeleteHairServiceDetails(clinicHairServiceMasterByClinicId[0]?._id, item)}
                        >
                          Delete
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <div className="card-body p-0 pb-3">
                    <ul className="list-group list-group-flush">
                      <li
                        className={classNames(styles.list, "list-group-item")}
                      >
                        <b className={styles.clinicName}>Service Name:</b>
                        <span className="text-black ms-2">
                          {item?.serviceDetailName}
                        </span>
                      </li>
                      <li
                        className={classNames(styles.list, "list-group-item")}
                      >
                        <b className={styles.clinicName}>Client Price:</b>
                        <span className="text-black ms-2">
                          {item?.client_price || "N/A"}
                        </span>
                      </li>
                      <li
                        className={classNames(styles.list, "list-group-item")}
                      >
                        <b className={styles.clinicName}>Pateint Price:</b>
                        <span className="text-black ms-2">
                          {item?.pt_price || "N/A"}
                        </span>
                      </li>
                      <li
                        className={classNames(styles.list, "list-group-item")}
                      >
                        <b className={styles.clinicName}>Tax:</b>
                        <span className="text-black ms-2">
                          {item?.tax || "N/A"}
                        </span>
                      </li>
                      <li
                        className={classNames(styles.list, "list-group-item")}
                      >
                        <b className={styles.clinicName}>Status:</b>
                        <span className="text-black ms-2">
                          {item?.status || "N/A"}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            )
          )}
      </div>
      <UpdateHairServiceDetails
        editHairServiceModal={editHairServiceModal}
        setEditHairServiceModal={setEditHairServiceModal}
        hairServiceDetailsFormData={hairServiceDetailsFormData}
        handleSubmitUpdateHairServiceDetails={handleSubmitUpdateHairServiceDetails}
        handleChangeHairServiceFormData={handleChangeHairServiceFormData}
      />
      <Modal
        centered
        show={deleteModal}
        onHide={() => setDeleteModal(false)}
        size={"md"}
      >
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">
            Confirm Delete
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setDeleteModal(false)}
          ></button>
        </div>
        <div className="modal-body">
          <p>
            Are you sure you want to delete {" "}
            <strong className="text-dark">
              {hairServiceDetailsFormData?.serviceDetailName}
            </strong> {" "}
            Hair service ?
          </p>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setDeleteModal(false)}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleConfirmDelete}
          >
            Delete
          </button>
        </div>
      </Modal>
    </>
  );
};

export default ClinicHairServiceMaster;
